<template>
  <FavouriteCard
    :color="apartmentDisplayColor(apartment)"
    :color-diamond="apartment.available ? null : 'black'"
    :url="url"
    :removable="apartment.type == 'owner-occupancy' ? false : interactive"
    v-on="$listeners"
    class="application-apartment-card"
  >
    <template #title>
      {{apartment.mpc_huoneistotyyppi}}, {{apartmentDisplayArea(apartment)}}{{apartmentDisplayFloor(apartment)}}<br>
      {{apartment.mpc_name}}
    </template>
    <template #sub-title>
      {{apartmentDisplayLocation(apartment)}}<br>
      {{apartment.building && (apartment.building.mpc_talotyyppi ? translate(apartment.building.mpc_talotyyppi) : '')}}
    </template>
    <template
      v-if="apartment.available"
      #bottom
    >
      <div class="application-apartment-card__specs">

        <div class="application-apartment-card__spec stacked-spec">
          <div v-if="isReserved"
               class="reserved">
            <div class="stacked-spec__title">
              &nbsp;
            </div>
            <div class="stacked-spec__value">
              {{translate('Varattu')}}
            </div>
          </div>
          <div v-else>
            <div class="stacked-spec__title">
              {{translate('Vapaa')}}
            </div>
            <div class="stacked-spec__value">
              {{apartmentDisplayAvailable(apartment)}}
            </div>
          </div>
        </div>

        <div class="application-apartment-card__spec stacked-spec">
          <div class="stacked-spec__title">
            {{translate(apartmentDisplayPriceTitle(apartment))}}
          </div>
          <div class="stacked-spec__value">
            {{apartmentDisplayPrice(apartment)}}
          </div>
        </div>

      </div>
    </template>
  </FavouriteCard>
</template>

<script>
  import apartmentDisplayFields from '../mixins/apartmentDisplayFields';
  import utils from '../mixins/utils';
  import FavouriteCard from './FavouriteCard';

  export default {
    mixins: [
      apartmentDisplayFields,
      utils.apartmentUrl,
      utils.translate,
    ],
    components: {
      FavouriteCard
    },
    props: {
      apartment: {
        type: Object,
        required: true,
      },
      interactive: {
        type: Boolean,
        required: true,
      }
    },
    computed: {
      url() {
        return this.apartment.available
          ? `${this.apartmentUrl(this.apartment)}?back=application`
          : null;
      },
      isReserved() {
        return this.apartment.mpc_status === 'Varattu';
      }
    }
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-apartment-card {
  }

  .application-apartment-card__specs {
    display: flex;
    flex-wrap: wrap;
    margin: r(-10);
  }

  .application-apartment-card__spec {
    margin: r(10);
  }
</style>
